import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";
import { z } from "zod";
import { RecentCalls } from "@/components/recent-calls"; // Using the placeholder component

const callLogsSearchSchema = z.object({
  page: z.number().optional().default(0),
  search: z.string().optional(),
});

// Update route path to match new location
export const Route = createFileRoute("/_app/$tenantId/call-logs")({
  component: CallLogsRouteComponent,
  validateSearch: callLogsSearchSchema,
});

function CallLogsRouteComponent() {
  const searchParams = useSearch({
    from: "/_app/$tenantId/call-logs",
  });
  const { tenantId } = useParams({ from: "/_app/$tenantId/call-logs" });

  return (
    <RecentCalls
      fullView={true}
      searchParams={searchParams}
      tenantId={tenantId}
    />
  );
}
